import PublicActivityType from '@/pages/publicPages/PublicActivityType/PublicActivityType';
import PublicActivityTypeSSP from '@/pages/publicPages/PublicActivityType/PublicActivityType.ssp';
import PageMetadata from '@/v2/domains/SEO/components/PageMetadata/PageMetadata';

export default function Games(props) {
  return (
    <>
      <PageMetadata
        title="Spanish Games for Kids | Online Spanish learning Games | Rockalingua"
        description="Fun vocabulary and high frequency structures reinforcement games, featuring drag-and-match, concept race, and memory match activities!"
      />
      <PublicActivityType {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicActivityTypeSSP({ context, activityType: 'game' });
